/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import CompletedJobItem from "./CompletedJobItem";

const CompletedJobItemList = ({ job }) => (
  <Table bordered striped>
    <thead>
      <tr>
        <th>Item ID</th>
        <th>Item</th>
        <th>Quantity</th>
        <th>Delivery Status</th>
        <th>Code/Reason</th>
      </tr>
    </thead>
    <CompletedJobItem job={job} jobItems={job.jobItems} />
  </Table>
);
CompletedJobItemList.propTypes = {
  job: PropTypes.object.isRequired
};

export default CompletedJobItemList;



// WEBPACK FOOTER //
// ./src/components/jobs/show/CompletedJobItemList.js